import React, {useContext, useEffect, useRef, useState} from "react";
import {TIPO_ELEMENTO_LISTA} from "../../../../utility/common";
import {TranslateContext} from "../../../../context/TranslateContext";
import {KpiContext} from "../../../../context/KpiContext";
import CampoInputLista from "./CampoInputLista";
import InputKpiView from "./InputKpiView";
import CampoInputTextarea from "./CampoInputTextarea";
import CampoInputTesto from "./CampoInputTesto";

export default function InputKpiEsrsController({
                                                   tabella,
                                                   idxLivello,
                                                   idxSottolivello,
                                                   idxElemento,
                                                   handlerChange,
                                                   disabled = false,
                                                   modifica = true,
                                                   formikRef,
                                                   errors,
                                                   values,
                                                   valEsrs,
                                                   topic,
                                                   idUtenteLoggato
                                               }) {

    const [valore, setValore] = useState();
    const [elemento, setElemento] = useState();

    const {translate} = useContext(TranslateContext);
    const {fieldKpiFocus, setIdFieldKpiFocus} = useContext(KpiContext);

    const fieldRef = useRef(null);

    useEffect(() => {
        if (topic) {
            let elementoSelezionato = tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento];

            let newEl;
            if (!elementoSelezionato[topic.id_topic]) {
                newEl = JSON.parse(JSON.stringify(elementoSelezionato));
                newEl.valore = valEsrs || '';
                newEl.cella += '_' + topic.id_topic;

                tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento][topic.id_topic] = newEl;
            } else {
                newEl = tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento][topic.id_topic];
            }

            setValore(newEl.valore)
            setElemento(newEl);

            formikRef.current.setFieldValue(newEl.cella, newEl.valore)
        }
    }, [tabella, idxLivello, idxSottolivello, idxElemento, valEsrs, topic]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (elemento?.id_kpi_elemento === fieldKpiFocus) {
                fieldRef.current?.focus();
            }
        }, 200);

        return () => {
            clearTimeout(timer);
        }
    }, [elemento, fieldKpiFocus]);

    function onFocusCampo() {
        setIdFieldKpiFocus(elemento.id_kpi_elemento)
    }

    function onChangeCampo(event) {
        formikRef.current.setFieldValue(elemento.cella, event.target.value);
        setValore(event.target.value);
    }

    function onBlurCampo(event) {
        let elementoSelezionato = tabella[idxLivello].sottolivelli[idxSottolivello].elementi[idxElemento];

        // Aggiorno il valore dell'elemento rispetto al topic
        if (!elementoSelezionato[topic.id_topic].valore) {
            elementoSelezionato[topic.id_topic].valore = '';
        }

        if (elementoSelezionato[topic.id_topic].valore != valore) {
            elementoSelezionato[topic.id_topic].valore = valore;

            // Aggiorno il valore json dell'elemento
            updateTopicValori(elementoSelezionato);

            // Richiamo l'aggiornamento della tabella
            setTimeout(() => {
                handlerChange(tabella);
            }, 5)
        }
    }

    function updateTopicValori(elementoSelezionato) {
        let topicsValori = elementoSelezionato.topics_valori;
        if (!topicsValori) {
            // Inizializzo l'array di valori se non è ancora presente
            topicsValori = [];
        }

        let valTopic;

        // Controllo se è già presente un valore per il topic e l'utente attuale
        const valsTopic = topicsValori.filter((vt) => vt.id_topic == topic.id_topic && vt.id_utente == idUtenteLoggato);
        if (valsTopic && valsTopic.length > 0) {
            valTopic = valsTopic[0];
            valTopic.value = valore;
        } else {
            topicsValori.push({
                id_utente: idUtenteLoggato,
                id_topic: topic.id_topic,
                descr_topic: topic.descrizione,
                value: valore
            });
        }
        elementoSelezionato.topics_valori = topicsValori;
    }

    function onValidate(value) {
        if ((!elemento.tipo_anno || elemento.tipo_anno == '0')
            && (parseInt(elemento.obbligatorio) === 1 && (!value || value === ''))) {
            return translate('Questo campo è obbligatorio');
        }
    }

    function getCampoInput() {
        if (elemento.tipo == TIPO_ELEMENTO_LISTA) {
            return modifica === true ?
                <CampoInputLista
                    elemento={elemento}
                    disabled={disabled}
                    fieldRef={fieldRef}
                    valore={valore}
                    onFocusCampo={onFocusCampo}
                    onChangeCampo={onChangeCampo}
                    onBlurCampo={onBlurCampo}
                    onValidate={onValidate}
                />
                :
                <span className={'sost-span-tabella-kpi'}>{valore}</span>
        } else if (elemento.placeholder && elemento.placeholder !== '') {
            return modifica === true ?
                <CampoInputTextarea
                    elemento={elemento}
                    valore={valore}
                    disabled={disabled}
                    formikRef={formikRef}
                    modifica={modifica}
                    onFocusCampo={onFocusCampo}
                    onChangeCampo={onChangeCampo}
                    onBlurCampo={onBlurCampo}
                    onValidate={onValidate}
                />
                :
                <span className={'sost-span-tabella-kpi'}>{valore}</span>

        } else {
            return <CampoInputTesto
                tabella={tabella}
                elemento={elemento}
                valore={valore}
                fieldRef={fieldRef}
                disabled={disabled}
                modifica={modifica}
                onFocusCampo={onFocusCampo}
                onChangeCampo={onChangeCampo}
                onBlurCampo={onBlurCampo}
                onValidate={onValidate}
            />
        }
    }

    return (
        <InputKpiView
            elemento={elemento}
            getCampoInput={getCampoInput}
        />
    );
}